import { useDebounce, useGetEnterprisesAutocomplete } from "@api";
import { useCallback, useEffect, useState } from "react";
import type { IEnterpriseBody } from "../context";

export const useAutocompleteEnterprise = () => {
  const [{ data, loading }, getEnterprises, cancel] = useGetEnterprisesAutocomplete();
  const [values, setValues] = useState<IEnterpriseBody[]>([]);

  const handleDebounce = useDebounce(
    (value: string) => {
      setValues([]);
      getEnterprises({ search: value, limit: 6 });
    },
    1000,
    [getEnterprises]
  );

  const loadOnType = useCallback(
    (value: string) => {
      if (loading) {
        cancel();
      }
      if (value) {
        handleDebounce(value);
      } else {
        setValues([]);
      }
    },
    [handleDebounce, loading, cancel]
  );

  useEffect(() => {
    if (data) {
      setValues(data);
    }
  }, [data]);

  return { enterprises: values, loading, loadOnType };
};
